import styled from 'styled-components';
import { Container } from '@mindly/ui-components';
import { IonModal } from '@ionic/react';

type StyledSpecialistProfileVideoModalProps = {
  isLoading?: boolean;
};

export const StyledSpecialistProfileVideoModal = styled(IonModal)<StyledSpecialistProfileVideoModalProps>`
  &::part(content) {
    --max-width: 340px;
    --height: auto;
    --background: transperent;
    --box-shadow: none;
  }
`;

export const StyledSpecialistProfileContainer = styled(Container)`
  padding-bottom: 30px;
  ion-icon {
    align-self: flex-end;
    padding-bottom: 10px;
    width: 35px;
    height: 35px;
    color: white;

    &:hover {
      color: #dedede;
      cursor: pointer;
    }
  }

  video {
    max-height: 80vh;
    object-fit: contain;
    height: auto;
    border-radius: 8px;
    background-color: black;
  }
`;
